<script>
// @ is an alias to /src
import Hero from "@/components/media/Hero.vue";

export default {
  name: "Programa de Trainee",

  head() {
    return this.$head({
      title: "Programas de trainne",
    });
  },

  components: {
    Hero,
  },
};
</script>

<template>
  <section>
    <div class="trainee">
      <Hero title="" :search="true" :image="'img-hero-programas.png'" />
      <div class="box-title d-flex align-items-center justify-content-center">
        <h2>Programas de Desenvolvimento</h2>
      </div>
      <section class="box1">
        <div class="container">
          <div class="top">
            <h2>Programa de <strong> Trainee </strong></h2>
          </div>
          <div class="content">
            Todos os anos preparamos talentos para assumir posições estratégicas
            no nosso time por meio do Programa Trainee do Grupo DPSP.
            <div class="space"></div>
            Após o processo de inscrição e seleção, que geralmente ocorre entre
            outubro e dezembro de cada ano, os candidatos ingressam na nossa
            empresa com um plano de desenvolvimento cheio de desafios que
            inclui:
          </div>
        </div>
      </section>
      <section class="box3">
        <div class="container">
          <div class="row p-5">
            <div class="box col-lg-6">
              <div class="icon">
                <img src="@/assets/images/dpsp/t1.svg" alt="" />
              </div>
              <div class="content">
                <h3>Job Rotation</h3>
                <p>
                  Vivência e conhecimento de diversas áreas, incluindo a
                  construção de projetos que contribuem com os resultados e
                  negócios da empresa.
                </p>
              </div>
            </div>
            <div class="box col-lg-6">
              <div class="icon">
                <img src="@/assets/images/dpsp/t3.svg" alt="" />
              </div>
              <div class="content">
                <h3>Visão 360º</h3>
                <p>
                  Além da atuação nas áreas da matriz, os trainees também têm a
                  oportunidade de trabalhar nas lojas e nos centros de
                  distribuição, conhecendo toda a cadeia do negócio, com uma
                  visão ampla de como o seu trabalho pode contribuir para a
                  evolução da empresa.
                </p>
              </div>
            </div>
            <div class="box col-lg-6">
              <div class="icon">
                <img src="@/assets/images/dpsp/t4.svg" alt="" />
              </div>
              <div class="content">
                <h3>Mentoria</h3>
                <p>
                  Cada trainee é acompanhado por um membro da alta liderança da
                  empresa, com agendas periódicas para conversas sobre carreira,
                  projetos, negócios e direcionamento, contribuindo para o
                  desenvolvimento profissional e pessoal de todos eles.
                </p>
              </div>
            </div>
            <div class="box col-lg-6">
              <div class="icon">
                <img src="@/assets/images/dpsp/t2.svg" alt="" />
              </div>
              <div class="content">
                <h3>Coaching</h3>
                <p>
                  Ao final do programa, os trainees passam por sessões de
                  coaching que contribuem com a preparação para assumirem um
                  novo cargo e o desenvolvimento de competências que essa
                  transição profissional exige.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.trainee {
  background: #fff;
}

.box3 {
  margin-bottom: 2rem;
  h3 {
    color: #2e3346;
    font-size: 2rem !important;
    font-family: "Nunito";
    margin: 1rem 0px 0.5rem 0px;
  }
  p {
    font-size: 1.5rem;
    line-height: calc(1.5rem * 1.7);
    color: #7f7f7f;
  }
  .box {
    margin-bottom: 2rem;
  }
  @include media-breakpoint-down(sm) {
    margin-bottom: 0rem;
    .box {
      margin-bottom: 1rem;
    }
    h3 {
      margin: 0.8rem 0px 0.5rem 0px;
      font-size: 1.5rem !important;
    }
    img {
      width: 80px;
    }
  }
}

.box1,
.box2 {
  margin: 4rem 0px;
  .top {
    background-color: #f7dd6a;
    padding: 1rem;
    padding-left: 24%;
    margin-left: -20%;
    margin-top: 4rem;
    width: 60%;
    max-width: 730px;
    border-top-right-radius: 100px;
    border-bottom-right-radius: 100px;
    z-index: 9;
    position: relative;
    h2 {
      color: #2e3346;
      font-size: 3.7rem !important;
      font-family: "Nunito-bold";
      strong {
        font-family: "Nunito-bold" !important;
        font-weight: bold !important;
        -webkit-text-stroke-width: 2px;
        -webkit-text-stroke-color: #2e3346;
        display: block;
        line-height: calc(4rem * 1);
      }
    }
    @include media-breakpoint-down(sm) {
      h2 {
        font-size: 1.7rem !important;
        strong {
          font-family: "Nunito-bold" !important;
          font-weight: bold !important;
          -webkit-text-stroke-width: 1px;
          -webkit-text-stroke-color: #2e3346;
          display: block;
          line-height: calc(1.7rem * 1);
        }
      }
    }
  }
  .content {
    padding: 7rem 7rem 4rem 24%;
    margin-left: -20%;
    margin-top: -5rem;
    background-color: #f0f1f2;
    border-top-right-radius: 500px;
    border-bottom-right-radius: 500px;
    font-size: 1.6rem;
    line-height: calc(1.6rem * 1.85);
    color: #7f7f7f;
    @include media-breakpoint-down(sm) {
      font-size: 1rem;
      border-top-right-radius: 50px;
      border-bottom-right-radius: 50px;
      line-height: calc(1rem * 1.85);
    }
  }
}

.box2 {
  margin-bottom: 2rem;
  .top {
    background-color: #f7dd6a;
  }
}

mark {
  background-color: #ffa1e3;
  border-radius: 50px;
}

.space {
  display: block;
  margin: 3rem 0px;
}

.box-title {
  height: 120px;
  width: 100%;
  background-color: theme-color(primary);
  text-align: center;
  margin: -7rem 0px 0px 0px;
  position: relative;
  z-index: 99;
  h2 {
    color: #fff;
  }
  @include media-breakpoint-down(md) {
    h2 {
      margin-top: 0.2rem !important;
      font-size: 1.7rem !important;
    }
  }
  @include media-breakpoint-down(sm) {
    height: 70px;
    h2 {
      margin-top: 0.2rem !important;
      font-size: 1.2rem !important;
    }
  }
}
</style>
